import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface EmailVerifyRequestModel {
	readonly userId: string;
	readonly emailVerifyCode: string;
}

export const useEmailVerify = () => {
	const http = useHTTP("None");

	const mutationFn: MutationFunction<HTTPResponse, EmailVerifyRequestModel> = requestModel => {
		return http<undefined, EmailVerifyRequestModel>({
			method: "POST",
			url: "/auth/verify",
			body: requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
